<template>
	<div v-if="camp.running !== 0" class="edu-card-link" @click="handleClick(camp)">
		<template v-if="camp.edu_camp_group">
			<c-edu-card
				:category="camp.edu_camp_group.top_category"
				:background-image="camp.edu_camp_group.title_img"
				:caption-left="camp.start_date | computedCaptionLeft"
				:additional-subtitle="additionalSubtitle"
			>
				<template v-slot:chip>
					<slot name="chip" />
				</template>
				<template v-slot:title>
					<slot name="title" />
				</template>
				<template v-slot:additionalCaptions>
					<slot name="additionalCaptions" />
				</template>
				<template v-slot:additional-button>
					<slot name="additional-button" />
				</template>
			</c-edu-card>
		</template>
		<template v-else>
			<c-edu-card
				:category="camp.top_category"
				:background-image="camp.title_img"
				:caption-left="camp.running && `${camp.running}개의 스케쥴`"
				:caption-right="camp.start_date | computedCaptionLeft"
				:additional-subtitle="additionalSubtitle"
			>
				<template v-slot:chip>
					<slot name="chip" />
				</template>
				<template v-slot:title>
					<slot name="title" />
				</template>
				<template v-slot:additionalCaptions>
					<slot name="additionalCaptions" />
				</template>
				<template v-slot:additional-button>
					<slot name="additional-button" />
				</template>
			</c-edu-card>
		</template>
	</div>
</template>

<script>
// 아직 다른 곳에서 쓰는 게 없어서 로컬로 처리
import dayjs from 'dayjs';

const monthAndDateTemplate = 'M월 D일';

function formatDate(date, template) {
	return dayjs(date).isValid() ? dayjs(date).format(template) : date;
}

export default {
	name: 'EduCardWithLink',
	props: {
		camp: {
			type: Object,
			default: () => {},
		},
		isFreeSchedule: {
			type: Boolean,
			default: false,
		},
		type: String,
	},
	data() {
		return {
			monthAndDateTemplate,
		};
	},
	computed: {
		getCardLinkUrl() {
			if (this.type === 'classroom') return false;
			const campUrl = new URL(this.camp.url);
			if (this.isFreeSchedule) {
				campUrl.searchParams.append('freeSchedule', true);
			}

			return campUrl.toString();
		},
		additionalSubtitle() {
			return this.camp.round > 1 ? `${this.camp.round}차 앵콜` : '';
		},
	},
	methods: {
		handleClick(camp) {
			this.$emit('clickEduCard', camp);
			if (this.type === 'classroom') return false;

			location.href = this.getCardLinkUrl;
		},
	},
	filters: {
		computedCaptionLeft(value) {
			const year = value.split('-')[0];
			if (year === '9999') return '자율일정';
			return `${formatDate(value, monthAndDateTemplate)}부터`;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../../scss/base/main';

.edu-card-link {
	width: 100%;
}
.edu-card-swiper-skeleton {
	&:not(:last-child) {
		margin-right: 16px;
		@include pc {
			margin-right: 24px;
		}
	}
}
</style>
